import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  children?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleAuthButtonClick = () => {
    if (isLoggedIn) {
      setIsLoggedIn(false);
    }
    navigate("/login");
  };

  const showLoginButton = location.pathname === "/";

  return (
    <header className=" border-2 border-gray-100">
      <nav
        className="mx-auto flex items-center justify-between lg:px-4"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <a href="#" className="-m-1.5 p-1.5">
            <svg
              width="228"
              height="72"
              viewBox="0 0 228 84"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M63.134 23.2084C60.2078 18.9305 54.2299 18.9305 51.2897 23.2084L42.3438 36.2928C41.884 36.9756 42.6643 37.8256 43.375 37.4076C50.3565 33.422 58.039 30.8154 66.0045 29.7297C66.1575 29.709 66.3026 29.6495 66.4261 29.557C66.5496 29.4644 66.6474 29.3418 66.7103 29.2008C66.7731 29.0598 66.7988 28.9051 66.785 28.7513C66.7713 28.5976 66.7184 28.4499 66.6315 28.3223L63.134 23.2084Z"
                fill="#74A488"
              />
              <path
                d="M41.8697 63.6192C42.0331 63.6175 42.1939 63.5776 42.3391 63.5026C42.4843 63.4276 42.6099 63.3196 42.7058 63.1872C50.105 53.3355 61.4476 47.0232 74.1837 47.0232C75.7205 47.0138 77.2564 47.1022 78.782 47.288C78.8595 47.2988 78.9383 47.2869 79.0091 47.2537C79.0799 47.2206 79.1396 47.1676 79.1809 47.1012C79.2222 47.0349 79.2433 46.958 79.2418 46.8798C79.2402 46.8017 79.2161 46.7256 79.1722 46.6609L76.7755 43.1773C76.6114 42.9348 76.3918 42.7349 76.1349 42.5943C75.878 42.4537 75.5912 42.3765 75.2984 42.3691H74.1837C58.7443 42.3691 44.8656 50.6323 36.3795 63.02C36.3388 63.0785 36.3149 63.1471 36.3104 63.2182C36.3058 63.2894 36.3209 63.3605 36.354 63.4237C36.387 63.4869 36.4367 63.5398 36.4977 63.5767C36.5588 63.6137 36.6287 63.6331 36.7 63.6331L41.8697 63.6192Z"
                fill="#2E69DF"
              />
              <path
                d="M49.423 62.9919C49.3796 63.0485 49.3526 63.116 49.3448 63.1869C49.3371 63.2578 49.349 63.3295 49.3791 63.3941C49.4093 63.4588 49.4566 63.5139 49.5159 63.5536C49.5753 63.5932 49.6443 63.6158 49.7156 63.6189H76.3164C81.2213 63.6189 84.4263 58.7419 83.5066 54.1435C83.4141 53.7287 83.207 53.3482 82.9089 53.0452C82.6109 52.7422 82.2338 52.5289 81.8205 52.4296C79.3225 51.8111 76.7579 51.5022 74.1845 51.5099C64.4164 51.5099 55.6098 55.9271 49.423 62.9919Z"
                fill="#0357C9"
              />
              <path
                d="M31.015 53.8086C30.4976 55.8779 30.8075 58.0675 31.879 59.9119C31.896 59.9445 31.9214 59.972 31.9525 59.9916C31.9836 60.0112 32.0193 60.0223 32.0561 60.0237C32.0928 60.0251 32.1293 60.0168 32.1618 59.9996C32.1943 59.9824 32.2217 59.957 32.2413 59.9258C41.6052 46.9946 56.097 38.5086 72.47 37.9651C72.5416 37.9622 72.6111 37.9403 72.6715 37.9017C72.7319 37.8631 72.7809 37.8091 72.8135 37.7453C72.8461 37.6815 72.8612 37.6101 72.8571 37.5386C72.8531 37.467 72.8301 37.3978 72.7905 37.3381L70.8118 34.4676C70.6538 34.2409 70.44 34.0589 70.1909 33.9393C69.9419 33.8196 69.6661 33.7664 69.3905 33.7848C54.4667 35.0668 41.0896 42.243 31.3495 53.1815C31.19 53.3612 31.0753 53.5761 31.015 53.8086Z"
                fill="#5887E6"
              />
              <path
                d="M98.3975 52.1108V33.382H93.6636V31.5215H105.137V33.382H100.444V52.1108H98.3975Z"
                fill="#0357C9"
              />
              <path
                d="M120.186 52.1108V42.457H109.519V52.1108H107.472V31.5215H109.519V40.5965H120.186V31.5215H122.232V52.1108H120.186Z"
                fill="#0357C9"
              />
              <path
                d="M125.333 52.1108V31.5215H136.599V33.382H127.4V40.7825H136.31V42.643H127.4V50.2503H136.599V52.1108H125.333Z"
                fill="#0357C9"
              />
              <path
                d="M161.323 52.1108L158.346 45.1857H148.775L145.777 52.1108H143.627L152.413 31.5215H154.728L163.597 52.1108H161.323ZM153.591 33.8574L149.56 43.3252H157.54L153.591 33.8574Z"
                fill="#0357C9"
              />
              <path
                d="M176.909 52.1108L169.922 42.7877H171.927C175.566 42.7877 177.736 40.9066 177.736 38.1158C177.736 36.152 176.537 33.382 171.803 33.382H167.896V52.1108H165.829V31.5215H172.051C177.426 31.5215 179.803 34.6843 179.803 38.1572C179.803 41.6301 177.302 44.1521 173.684 44.4208L179.493 52.1108H176.909Z"
                fill="#0357C9"
              />
              <path
                d="M194.646 52.1108L187.762 43.1805L185.116 46.4466V52.1108H183.028V31.5215H185.116V43.3458H185.158L194.605 31.5215H197.23L189.085 41.5681L197.23 52.1108H194.646Z"
                fill="#0357C9"
              />
            </svg>
          </a>
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          {children}
          {showLoginButton && (
            <button
              onClick={handleAuthButtonClick}
              className="text-sm text-gray-500 font-semibold leading-6 cursor-pointer"
            >
              {isLoggedIn ? "" : "Login"}
            </button>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
